import apiClient from './apiClient';
import { Certificate, CertificateListResponse } from '../types/certificate';

class CertificateService {
  private baseUrl = '/certificates';

  async upload(companyId: number, file: File, password: string): Promise<Certificate> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('companyId', String(companyId));
    formData.append('password', password);

    const response = await apiClient.post(`${this.baseUrl}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data?.data ?? response.data;
  }

  async list(filters?: { companyId?: number }): Promise<CertificateListResponse> {
    const params = new URLSearchParams();
    if (filters?.companyId) params.append('companyId', String(filters.companyId));

    const response = await apiClient.get<CertificateListResponse>(`${this.baseUrl}?${params.toString()}`);
    return (response as unknown as CertificateListResponse) ?? { data: [], total: 0 };
  }

  async getById(id: number): Promise<Certificate> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data?.data ?? response.data;
  }

  async remove(id: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async validate(id: number): Promise<Certificate> {
    const response = await apiClient.get(`${this.baseUrl}/${id}/validate`);
    return response.data?.data ?? response.data;
  }
}

export const certificateService = new CertificateService();
export default certificateService;
